var Editor2DModel = require("../editor2D/editor2DModel.js");
var Editor2DController = require("../editor2D/editor2DController.js");

var Camera2DController = require("../camera2D/camera2DController.js");

var lib_core      = require("lib-core");

var SelectionStateMachine = require("./selectionStateMachine.js");
var SelectionView         = require("./selectionView.js");
var SelectionModel        = require("./selectionModel.js");

var SelectionController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SelectionController, lib_core.Controller);
SelectionController.inject = {
    editor2dController : Editor2DController,
    camera2DController   : Camera2DController
};

module.exports = SelectionController;

SelectionController.prototype.createStateMachine = function () {
    return new SelectionStateMachine(this.root, this.getModel(), this.camera2DController.getModel());
};

SelectionController.prototype.createModel = function () {
    var selectionModel = new SelectionModel();

    //todo next line needs to go
    this.parent().getModel().selectionModel = this.parent().getModel().value("selectionModel", false);
    this.parent().getModel().selectionModel(selectionModel);
    
    return selectionModel;
};

SelectionController.prototype.createView = function () {
    return new SelectionView(this.getModel(), this.parent().getView(), this.camera2DController.getModel());
};

SelectionController.prototype.afterBuild = function () {
    var self = this;

    // add connection to snapGroupModel so SM can update it
    var mod = this.editor2dController.getModel();
    if(mod != null) {
        mod = mod.submodel.get("selection");
        if(mod != null) {
            mod = mod.submodel.get("moving");
            if(mod != null) {
                mod = mod.submodel.get("snap");
                if(mod != null) {
                    this.getModel().snapModel = mod;
                }
            }
        }
    }
};
